import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Snackbar } from '@plataforma/components';
import { fetchProcessDetail } from '../actions';
import ProcessDetailWrapper from '../components/ProcessDetailWrapper';
import useQuery from '../../../hooks/useQuery';

function ProcessDetail() {
  const { t } = useTranslation();
  const { policy, isFetching } = useSelector(status => {
    return status.policyDetail;
  });
  const queryParams = useQuery();
  const paramsId =
    queryParams.get('quoteId') || queryParams.get('documentNumber');
  const [toast, setToastOpen] = useState({
    isOpen: false,
    message: t('generic.copyLinkMessage'),
    type: 'success'
  });
  const dispatch = useDispatch();

  const fetchDetails = useCallback(
    params => {
      dispatch(fetchProcessDetail(Number(paramsId), params));
    },
    [dispatch, paramsId]
  );

  function handleToastStatus(toastStatus) {
    setToastOpen(prev => ({ ...prev, ...toastStatus }));
  }

  useEffect(() => {
    const broker = JSON.parse(window.localStorage.getItem('broker'));
    fetchDetails(queryParams.toString(), broker.externalId);
  }, [fetchDetails, queryParams]);

  return (
    <>
      <ProcessDetailWrapper
        isFetching={isFetching}
        policy={policy}
        onToastHandler={handleToastStatus}
      />
      <Snackbar
        open={toast.isOpen}
        message={toast.message}
        variant={toast.type}
        onClose={() => handleToastStatus({ isOpen: false })}
      />
    </>
  );
}

export default ProcessDetail;
